import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { FolderGit2, FolderKanban } from 'lucide-react';
import Image from 'next/image';
interface WorkstreamBannerBackgroundProps {
  isNetworkBanner: boolean;
  backgroundImage?: string;
}
function WorkstreamBannerBackground(t0) {
  const $ = _c(10);
  const {
    isNetworkBanner,
    backgroundImage
  } = t0;
  if (isNetworkBanner) {
    let t1;
    if ($[0] !== backgroundImage) {
      t1 = backgroundImage && <Image src={backgroundImage} alt="Workstream banner background" fill={true} sizes="100vw" unoptimized={true} className="object-cover" priority={true} />;
      $[0] = backgroundImage;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== t1) {
      t2 = <div className="bg-primary pointer-events-none absolute inset-0 z-0"><div className="relative h-full w-full">{t1}</div></div>;
      $[2] = t1;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  let t1;
  let t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className={cn("bg-primary absolute size-50 rounded-full opacity-30 blur-[75px] transition-all duration-1000 ease-in-out", "-top-18 -right-13", "sm:-top-11 sm:left-[48.1%]", "xl:-top-11 xl:left-[59%]", "2xl:left-[53%]")} />;
    t2 = <div className={cn("bg-primary absolute size-50 rounded-full opacity-50 blur-[50px] transition-all duration-1000 ease-in-out", "-bottom-33 -left-1", "lg:-bottom-40", "xl:-bottom-39")} />;
    t3 = <div className={cn("bg-primary absolute hidden size-24 rounded-full blur-[50px] transition-all duration-1000 ease-in-out", "-top-6 -right-24", "sm:-top-4 sm:-right-27 sm:block", "md:-top-3 md:-right-22", "2xl:right-6")} />;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <FolderKanban className={cn("text-border absolute -top-4 right-1 size-24 rotate-[19deg] transition-all duration-500 ease-in-out", "sm:right-[15%]", "lg:-top-0 lg:right-[25%]", "xl:-top-1 xl:right-[22%]")} />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <FolderKanban className={cn("text-muted-foreground/50 absolute -bottom-10 -left-4 size-39 -rotate-[19deg] transition-all duration-500 ease-in-out", "lg:-bottom-7 lg:-left-3")} />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="pointer-events-none absolute inset-0 z-0">{t1}{t2}{t3}{t4}{t5}<FolderGit2 className={cn("text-muted-foreground/50 absolute right-0 bottom-0 hidden size-32 -rotate-[15deg] transition-all duration-500 ease-in-out", "sm:-right-5 sm:-bottom-4 sm:block", "md:-right-2 md:-bottom-1", "lg:-right-1 lg:bottom-3", "xl:right-1")} /><div className="border-accent bg-secondary/50 absolute inset-0 rounded-lg border-[3px] backdrop-blur-[2px] transition-all duration-300 ease-in-out" /></div>;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}
export { WorkstreamBannerBackground };